import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../services/ThemeContext';

const LandingPage = () => {
  const { theme, toggleTheme } = useTheme();
  return (
    <div className="bg-offwhite text-darkgray antialiased min-h-screen transition-colors duration-300">
      <nav className="sticky top-0 z-50 bg-[var(--bg-main)]/80 backdrop-blur-md border-b border-[var(--border-light)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-20 items-center">
            <div className="flex items-center gap-2">
              <span className="material-icons text-tangerine text-3xl">change_history</span>
              <span className="font-bold text-xl tracking-tight text-black">Ally AI</span>
            </div>
            <div className="hidden md:flex space-x-8 items-center">
              <Link className="text-sm font-semibold text-gray-500 hover:text-tangerine transition-colors" to="/experts">Experts</Link>
              <Link className="text-sm font-semibold text-gray-500 hover:text-tangerine transition-colors" to="/about">About</Link>
              <a className="text-sm font-semibold text-gray-500 hover:text-tangerine transition-colors" href="#">Results</a>
              <a className="text-sm font-semibold text-gray-500 hover:text-tangerine transition-colors" href="#"><br /></a>
            </div>
            <div className="flex items-center space-x-4">
              <button
                onClick={toggleTheme}
                className="p-2 rounded-xl bg-[var(--off-white)] border border-[var(--border-light)] text-[var(--text-secondary)] hover:text-tangerine transition-all shadow-sm hover:shadow-md"
                aria-label="Toggle night mode"
              >
                <span className="material-symbols-outlined flex items-center justify-center">
                  {theme === 'light' ? 'dark_mode' : 'light_mode'}
                </span>
              </button>
              <Link to="/login" className="text-sm font-semibold text-gray-500 hover:text-tangerine transition-colors hidden md:block">
                Login
              </Link>
              <Link to="/register" className="bg-tangerine hover:bg-tangerine/90 text-white px-4 py-2 rounded-xl text-sm font-bold shadow-md shadow-tangerine/20 transition-all hover:-translate-y-0.5">
                Sign Up
              </Link>
            </div>
          </div>
        </div>
      </nav>

      <section className="pt-24 pb-20 lg:pt-32 lg:pb-32 px-4 bg-offwhite relative overflow-hidden">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-tangerine/5 rounded-full blur-3xl -z-10 opacity-40"></div>
        <div className="max-w-5xl mx-auto text-center relative z-10">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-black mb-8 leading-tight">
            Scale Human Expertise to<br className="hidden md:block" />
            Everyone, Everywhere
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-12 max-w-4xl mx-auto font-normal leading-relaxed">
            Ally connects people to world-class coaches and experts — making personalized guidance accessible, affordable, and scalable.
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-6">
            <button className="w-full sm:w-auto flex items-center justify-center gap-2 bg-[var(--surface-white)] border border-[var(--border-light)] hover:border-tangerine hover:text-tangerine text-[var(--text-primary)] px-8 py-4 rounded-2xl text-base font-bold transition-all shadow-sm hover:shadow-md">
              <span className="material-icons text-xl text-tangerine">play_circle_outline</span>
              Watch Demo
            </button>
            <Link className="w-full sm:w-auto bg-tangerine hover:bg-tangerine/90 text-white px-8 py-4 rounded-2xl text-base font-bold shadow-lg shadow-tangerine/20 transition-all hover:-translate-y-0.5 text-center" to="/login">
              Sign In
            </Link>
            <a className="text-tangerine hover:text-tangerine/80 font-semibold underline underline-offset-8 decoration-2 transition-colors text-base" href="#">
              Contact Us
            </a>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[var(--surface-white)] relative border-t border-[var(--border-light)] overflow-hidden" id="expert-network">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 relative">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-2">Expert Network</h2>
            <h3 className="text-xl text-tangerine font-bold mb-6">Featured Partners</h3>
            <p className="text-gray-500 max-w-2xl mx-auto">A few of the experts using Ally to democratize their services - many more are a part of our growing community</p>
            <div className="h-[2px] w-12 bg-tangerine/20 mx-auto mt-8 rounded-full"></div>
            <div className="absolute right-0 bottom-0 hidden md:flex items-center gap-2 text-gray-400">
              <span className="text-sm font-semibold uppercase tracking-wider"><br /></span>
              <span className="material-icons">arrow_forward</span>
            </div>
          </div>
        </div>
        <div className="pl-4 sm:pl-6 lg:pl-8 pr-4 sm:pr-6 lg:pr-8 mx-auto max-w-[100vw] overflow-x-auto pb-8 hide-scrollbar snap-x snap-mandatory">
          <div className="flex gap-8 w-max pr-[20vw] items-stretch">
            {/* Ashley Copley */}
            <div className="w-[300px] md:w-[380px] snap-center shrink-0 group bg-offwhite rounded-3xl overflow-hidden border border-gray-200/60 hover:border-tangerine/30 transition-all duration-300 shadow-sm hover:shadow-xl flex flex-col">
              <div className="aspect-w-4 aspect-h-3 overflow-hidden relative">
                <img alt="Ashley Copley Portrait" className="w-full h-80 object-cover object-center group-hover:scale-105 transition-transform duration-700" src="/photo/ashley.jpg" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                <div className="absolute top-6 right-6">
                  <div className="w-3 h-3 rounded-full bg-tangerine shadow-[0_0_10px_rgba(242,133,0,0.8)] border-2 border-white"></div>
                </div>
              </div>
              <div className="p-8 flex-1 flex flex-col">
                <h3 className="text-xl font-bold text-black mb-1">Ashley Copley</h3>
                <p className="text-tangerine font-bold text-xs mb-4 uppercase tracking-widest">AI Coaching Companion</p>
                <p className="text-gray-600 text-sm leading-relaxed mb-6 border-l-2 border-tangerine/20 pl-4 flex-1">
                  "Introducing Ally, Your AI Coaching Companion! As a human coach dedicated to helping you unlock your full potential, I've seen firsthand the power of consistent support and personalized guidance."
                </p>
                <a className="inline-flex items-center text-sm font-bold text-tangerine hover:gap-2 transition-all mt-auto" href="#">
                  Learn More <span className="material-icons text-sm ml-1">arrow_forward</span>
                </a>
              </div>
            </div>

            {/* Michael Legge */}
            <div className="w-[300px] md:w-[380px] snap-center shrink-0 group bg-offwhite rounded-3xl overflow-hidden border border-gray-200/60 hover:border-tangerine/30 transition-all duration-300 shadow-sm hover:shadow-xl flex flex-col">
              <div className="aspect-w-4 aspect-h-3 overflow-hidden relative">
                <img alt="Michael Legge Portrait" className="w-full h-80 object-cover object-center group-hover:scale-105 transition-transform duration-700" src="/photo/michael.jpg" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                <div className="absolute top-6 right-6">
                  <div className="w-3 h-3 rounded-full bg-tangerine shadow-[0_0_10px_rgba(242,133,0,0.8)] border-2 border-white"></div>
                </div>
              </div>
              <div className="p-8 flex-1 flex flex-col">
                <h3 className="text-xl font-bold text-black mb-1">Michael Legge</h3>
                <p className="text-tangerine font-bold text-xs mb-4 uppercase tracking-widest">Personal & Professional Growth</p>
                <p className="text-gray-600 text-sm leading-relaxed mb-6 border-l-2 border-tangerine/20 pl-4 flex-1">
                  "Hello, I'm Michael Legge. I'm excited to introduce you to my AI Ally, a personalized extension of my coaching that's here to support you 24/7."
                </p>
                <a className="inline-flex items-center text-sm font-bold text-tangerine hover:gap-2 transition-all mt-auto" href="#">
                  Learn More <span className="material-icons text-sm ml-1">arrow_forward</span>
                </a>
              </div>
            </div>

            {/* Placeholder 1 */}
            <div className="w-[300px] md:w-[380px] snap-center shrink-0 group bg-offwhite rounded-3xl overflow-hidden border border-gray-200/60 hover:border-tangerine/30 transition-all duration-300 shadow-sm hover:shadow-xl flex flex-col opacity-60">
              <div className="aspect-w-4 aspect-h-3 overflow-hidden relative bg-[var(--off-white)] flex items-center justify-center h-80">
                <span className="material-icons text-[var(--text-secondary)] text-8xl opacity-20">person</span>
                <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent"></div>
              </div>
              <div className="p-8 flex-1 flex flex-col">
                <h3 className="text-xl font-bold text-[var(--text-secondary)] mb-1">Partner Expert</h3>
                <p className="text-gray-400 font-bold text-xs mb-4 uppercase tracking-widest">Coming Soon</p>
                <p className="text-gray-400 text-sm italic leading-relaxed mb-6 border-l-2 border-gray-200 pl-4 flex-1">
                  Information will be added later.
                </p>
              </div>
            </div>

            {/* Placeholder 2 */}
            <div className="w-[300px] md:w-[380px] snap-center shrink-0 group bg-offwhite rounded-3xl overflow-hidden border border-gray-200/60 hover:border-tangerine/30 transition-all duration-300 shadow-sm hover:shadow-xl flex flex-col opacity-60">
              <div className="aspect-w-4 aspect-h-3 overflow-hidden relative bg-[var(--off-white)] flex items-center justify-center h-80">
                <span className="material-icons text-[var(--text-secondary)] text-8xl opacity-20">person</span>
                <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent"></div>
              </div>
              <div className="p-8 flex-1 flex flex-col">
                <h3 className="text-xl font-bold text-[var(--text-secondary)] mb-1">Partner Expert</h3>
                <p className="text-gray-400 font-bold text-xs mb-4 uppercase tracking-widest">Coming Soon</p>
                <p className="text-gray-400 text-sm italic leading-relaxed mb-6 border-l-2 border-gray-200 pl-4 flex-1">
                  Information will be added later.
                </p>
              </div>
            </div>

            <div className="w-[200px] snap-center shrink-0 flex items-center justify-center">
              <Link className="flex flex-col items-center justify-center gap-4 text-gray-500 hover:text-tangerine transition-colors group p-8 rounded-3xl border-2 border-dashed border-gray-200 hover:border-tangerine/30 h-full w-full" to="/experts">
                <div className="w-16 h-16 rounded-full bg-[var(--surface-white)] shadow-sm border border-[var(--border-light)] flex items-center justify-center group-hover:scale-110 transition-transform">
                  <span className="material-icons text-2xl">arrow_forward</span>
                </div>
                <span className="font-bold text-lg">See All<br />Experts</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-offwhite relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">Product Demo</h2>
          <p className="text-[var(--text-secondary)] mb-12">Making expert guidance personal with video, chats, voice and next steps</p>
          <div className="relative max-w-5xl mx-auto bg-[var(--surface-white)] rounded-[2rem] p-4 md:p-8 shadow-2xl shadow-black/5 border border-[var(--border-light)] @container">
            <div 
              className="bg-[var(--off-white)] rounded-2xl shadow-inner overflow-hidden border border-[var(--border-light)] mx-auto transform transition-transform duration-500 origin-top"
              style={{
                width: 'min(100%, 896px)',
                aspectRatio: '896/820',
                scale: 'calc(min(100cqi, 896px) / 896)',
              }}
            >
              <div className="bg-[var(--off-white)] border-b border-[var(--border-light)] p-4 flex items-center space-x-2">
                <div className="w-3 h-3 rounded-full bg-red-400"></div>
                <div className="w-3 h-3 rounded-full bg-amber-400"></div>
                <div className="w-3 h-3 rounded-full bg-emerald-400"></div>
              </div>
              <div className="flex" style={{ height: '750px' }}>
                <div className="w-64 bg-[var(--off-white)] border-r border-[var(--border-light)] p-4 flex flex-col justify-between">
                  <div className="space-y-4">
                    <div className="w-10 h-10 bg-[var(--surface-white)] rounded-xl flex items-center justify-center text-tangerine mb-4 shadow-sm border border-[var(--border-light)]">
                      <span className="material-icons text-xl">change_history</span>
                    </div>
                    <div className="space-y-3">
                      <div className="flex items-center space-x-3 p-3 bg-[var(--surface-white)] shadow-sm rounded-xl border border-tangerine/10">
                        <span className="material-icons text-tangerine text-lg">chat_bubble</span>
                        <span className="text-xs font-bold text-[var(--text-primary)]">Chat</span>
                      </div>
                      <div className="flex items-center space-x-3 p-3 text-[var(--text-secondary)] hover:text-tangerine hover:bg-[var(--surface-white)] rounded-xl cursor-pointer transition-all">
                        <span className="material-icons text-lg">school</span>
                        <span className="text-xs font-bold">Lessons</span>
                      </div>
                      <div className="flex items-center space-x-3 p-3 text-[var(--text-secondary)] hover:text-tangerine hover:bg-[var(--surface-white)] rounded-xl cursor-pointer transition-all">
                        <span className="material-icons text-lg">settings</span>
                        <span className="text-xs font-bold">Settings</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center space-x-3 p-3 text-[var(--text-secondary)] hover:text-red-500 transition-colors cursor-pointer">
                    <span className="material-icons text-lg">logout</span>
                    <span className="text-xs font-bold">Log out</span>
                  </div>
                </div>
                <div className="flex-1 bg-[var(--surface-white)] p-6 md:p-10 flex flex-col relative">
                  <div className="flex-1 space-y-8 overflow-y-auto pr-2">
                    <div className="flex items-start space-x-4 max-w-2xl">
                      <div className="w-10 h-10 rounded-xl bg-tangerine/10 flex items-center justify-center flex-shrink-0 border border-tangerine/5">
                        <span className="material-icons text-tangerine text-sm">smart_toy</span>
                      </div>
                      <div className="bg-[var(--off-white)] p-5 rounded-2xl rounded-tl-none border border-[var(--border-light)]">
                        <p className="text-sm text-[var(--text-primary)] leading-relaxed">
                          Hi! How can I help you improve your leadership skills today? We could review your recent team feedback or prepare for your upcoming board meeting.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start justify-end space-x-4">
                      <div className="bg-tangerine text-white p-5 rounded-2xl rounded-tr-none shadow-md shadow-tangerine/20">
                        <p className="text-sm leading-relaxed font-medium">
                          Let's prepare for the board meeting. I need to present the Q3 results but morale is low.
                        </p>
                      </div>
                      <div className="w-10 h-10 rounded-xl overflow-hidden flex-shrink-0 border border-[var(--border-light)] shadow-sm">
                        <img alt="User" className="w-full h-full object-cover" src="https://lh3.googleusercontent.com/aida-public/AB6AXuB71296bIg6ouPsRfPmiRBwdWd7els-TVBYQsIwHNmubQNyya_xvuCD6zd1zAgbT1gTLrUj_gWn964AaxQoWsZXUgbOc6RRjmb2LuN_EtQLjOerPRo9-SI9zNYmZhhIERWxrjJSgiVNQAiVqWNEu8UN9lcUMVeSvWsaW9TePFFQP-gXkOCZ9oqWBj4_4w7bXAF-kcicm_Z7JvjzCgqQBgaJyfEFunk6C-l8KfiddGyq_g21NxGMkB44OTEtKKy2F1eW5KdXTrDTCSk" />
                      </div>
                    </div>
                    <div className="flex items-start space-x-4 max-w-2xl">
                      <div className="w-10 h-10 rounded-xl bg-tangerine/10 flex items-center justify-center flex-shrink-0 border border-tangerine/5">
                        <span className="material-icons text-tangerine text-sm">smart_toy</span>
                      </div>
                      <div className="bg-[var(--off-white)] p-5 rounded-2xl rounded-tl-none border border-[var(--border-light)]">
                        <p className="text-sm text-[var(--text-primary)] leading-relaxed">
                          Understood. Balancing transparency with motivation is key here. Would you like to draft an opening statement that acknowledges the challenges while pivoting to future opportunities?
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-8 relative">
                    <input className="w-full bg-[var(--off-white)] border border-[var(--border-light)] rounded-2xl py-4 px-6 text-sm focus:outline-none focus:ring-2 focus:ring-tangerine/20 focus:border-tangerine/30 text-[var(--text-primary)] placeholder-[var(--text-secondary)] transition-all" placeholder="Type a message..." type="text" />
                    <button className="absolute right-2 top-2 w-10 h-10 bg-tangerine rounded-xl flex items-center justify-center text-white hover:bg-tangerine/90 transition-colors shadow-lg shadow-tangerine/20">
                      <span className="material-icons text-sm font-bold">arrow_upward</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[var(--surface-white)] border-y border-[var(--border-light)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-center text-sm font-bold mb-16 text-tangerine uppercase tracking-[0.3em]">Social Proof</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
            <div className="p-8 bg-offwhite rounded-3xl border border-[var(--border-light)] transition-transform hover:-translate-y-1">
              <div className="text-6xl font-bold text-black mb-3 tracking-tight">85%</div>
              <p className="text-sm text-gray-500 font-bold uppercase tracking-wider">Conversion Rate</p>
            </div>
            <div className="p-8 bg-offwhite rounded-3xl border border-[var(--border-light)] transition-transform hover:-translate-y-1">
              <div className="text-6xl font-bold text-black mb-3 tracking-tight">100K+</div>
              <p className="text-sm text-gray-500 font-bold uppercase tracking-wider">Sessions Conducted</p>
            </div>
            <div className="p-8 bg-offwhite rounded-3xl border border-[var(--border-light)] transition-transform hover:-translate-y-1">
              <div className="text-6xl font-bold text-black mb-3 tracking-tight">4.9/5</div>
              <p className="text-sm text-gray-500 font-bold uppercase tracking-wider">User Satisfaction</p>
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-offwhite py-16 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-10">
          <div className="flex items-center gap-2 md:order-1">
            <span className="material-icons text-tangerine text-2xl">change_history</span>
            <span className="font-bold text-lg text-black">Ally AI</span>
          </div>
          <div className="flex space-x-10 md:order-2">
            <a className="text-sm font-semibold text-gray-500 hover:text-tangerine transition-colors" href="#">Privacy</a>
            <a className="text-sm font-semibold text-gray-500 hover:text-tangerine transition-colors" href="#">Terms</a>
            <a className="text-sm font-bold text-tangerine hover:opacity-80 transition-colors" href="#">Contact</a>
          </div>
          <div className="flex space-x-6 md:order-3">
            <a className="text-gray-400 hover:text-tangerine transition-colors" href="#"><i className="material-icons text-xl">facebook</i></a>
            <a className="text-gray-400 hover:text-tangerine transition-colors flex items-center" href="#"><span className="font-bold text-lg leading-none">𝕏</span></a>
            <a className="text-gray-400 hover:text-tangerine transition-colors" href="#"><i className="material-icons text-xl">photo_camera</i></a>
          </div>
          <div className="text-xs font-semibold text-gray-400 md:order-4">
            © 2026 Ally AI Inc.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
